import posthog from 'posthog-js'

const KEY  = (import.meta.env.VITE_POSTHOG_KEY  as string | undefined) ?? 'phc_v4jw5mpXZhHTC9bRssfTpSehyGAzdD6ntBYC5fZjqoFw'
const HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://eu.i.posthog.com'

export function initPostHog() {
  posthog.init(KEY, {
    api_host:         HOST,
    person_profiles:  'identified_only',
    capture_pageview: true,
    autocapture:      false,
  })
}

export { posthog }
